import * as React from 'react';

import { TierComparisonDesktop } from '@/pages/unauthenticated/pricing/components/tier-comparisons/desktop';
import { TierComparisonMobile } from '@/pages/unauthenticated/pricing/components/tier-comparisons/mobile';

export const SectionTierComparison = () => {
  return (
    <section className="redesign-container py-12 md:py-24 md:pt-12">
      <div className="mx-auto max-w-7xl">
        <div className="mx-auto max-w-3xl text-center pb-16 hidden lg:block">
          <div className="mx-auto max-w-4xl text-center">
            <h2 className="text-base/7 font-semibold text-primary">
              Tier Comparison
            </h2>
            <p className="mt-2 text-5xl font-bold tracking-tight text-balance sm:text-6xl">
              Find your <span className="italic text-primary">fit</span>
            </p>
          </div>
          <p className="mx-auto mt-6 max-w-2xl text-center text-lg font-medium text-pretty text-muted-foreground sm:text-xl/8">
            See what each tier offers and pick the one that fits best.
          </p>
        </div>

        {/* Feature comparison (up to lg) */}
        <TierComparisonMobile />
        {/* Feature comparison (lg+) */}
        <TierComparisonDesktop />
      </div>
    </section>
  );
};
